<div id="models-select">
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <label>
          <span>*Marca</span>

          <select [(ngModel)]="brandSelected" (change)="populateModels($event.target.selectedIndex); selectBrand($event.target.value); editNewBrand(jsonParse($event.target.value).id, jsonParse($event.target.value).name);" #viewBrandSelected>
            <option value="">Selecione a marca</option>
            <option *ngFor="let brand of brands;" [value]="convertToJson(brand.cdProdutoMarca, brand.dsProdutoMarca)">{{ brand.dsProdutoMarca }}</option>
          </select>
        </label>
      </div>

      <div class="col">
        <label>
          <span>*Modelo</span>

          <select [disabled]="models.length == 0" [(ngModel)]="modelSelected" (change)="selectModel($event.target.value);">
            <option value="" *ngIf="models.length == 0">Selecione a marca antes</option>
            <option value="" *ngIf="models.length > 0">Selecione o modelo</option>
            <option *ngFor="let model of models;" [value]="convertToJson(model.cdProdutoModelo, model.dsProdutoModelo)">{{ model.dsProdutoModelo }}</option>
          </select>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <button (click)="openModal('brand');">CADASTRAR MARCA</button>
      </div>

      <div class="col">
        <button (click)="openModal('model');">CADASTRAR MODELO</button>
      </div>
    </div>
  </div>

  <div class="shadow" *ngIf="modal" (click)="closeModal();"></div>
  <div class="modal" *ngIf="modal">
    <span class="icn-close close" (click)="closeModal();"></span>

    <h1>Cadastrar marca/modelo</h1>

    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <label *ngIf="modalModel">
            <span>Marca</span>

            <select [(ngModel)]="brandSelected" (change)="populateModels($event.target.selectedIndex); selectBrand($event.target.value); editNewBrand(jsonParse($event.target.value).id, jsonParse($event.target.value).name);">
              <option value="">Selecione a marca</option>
              <option *ngFor="let brand of brands;" [value]="convertToJson(brand.cdProdutoMarca, brand.dsProdutoMarca)">{{ brand.dsProdutoMarca }}</option>
            </select>
          </label>

          <label *ngIf="modalBrand">
            <span>Marca</span>

            <input type="text" [(ngModel)]="newBrand.name" placeholder="Nome da marca">
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label>
            <span>Modelo</span>

            <input type="text" [(ngModel)]="newModel.name" placeholder="Nome do modelo">
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <button (click)="addBrandModel();">Cadastrar marca/modelo</button>
        </div>
      </div>
    </div>
  </div>
</div>
